import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_WORKSPACE_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/onboarding/pre-cadastro`;
export default{
    async listarPorId(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${encodeURI(id)}`);
    },     
    async listarPorDataCadastro(dataCadastroInicial, dataCadastroFinal, idPais, idJobReq, documento, primeiroNome, ultimoNome, status){
        let url = `${baseUrl}/data-cadastro/${dataCadastroInicial}/${dataCadastroFinal}?idPais=${encodeURI(idPais)}`;

        if(documento != null && documento != undefined)
            url = `${url}&documento=${encodeURI(documento)}`;

        if(idJobReq != null && idJobReq != undefined)
            url = `${url}&idJobReq=${encodeURI(idJobReq)}`;               

        if(primeiroNome != null && primeiroNome != undefined)
            url = `${url}&primeiroNome=${encodeURI(primeiroNome)}`;            

        if(ultimoNome != null && ultimoNome != undefined)
            url = `${url}&ultimoNome=${encodeURI(ultimoNome)}`;                

        if((status || []).length > 0)
            status.forEach(status => { url += `&status=${status.id}`;  });

        return await Vue.prototype.$httpJson.get(url);
    },    
    async sugerirEmail(idOnboarding, primeiroNome, ultimoNome){
        return await Vue.prototype.$httpJson.post(
            `${baseUrl}/sugerir-email`, {
                idOnboarding: idOnboarding,
                firstName: primeiroNome,
                lastName: ultimoNome
        });
    },
    async sugerirLogin(idOnboarding, primeiroNome, ultimoNome){     
        return await Vue.prototype.$httpJson.post(
            `${baseUrl}/sugerir-login`, {
                idOnboarding: idOnboarding,
                firstName: primeiroNome,
                lastName: ultimoNome
        });
    },
    async inserir(onboarding){
        return await Vue.prototype.$httpJson.post(baseUrl, onboarding);
    },
    async alterar(id, onboarding){
        return await Vue.prototype.$httpJson.put(`${baseUrl}/${encodeURI(id)}`, onboarding);
    }                       
}